import { TranslocoService } from '@jsverse/transloco';
import { Component, inject, Input, OnDestroy, Signal } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FuelLevelClusterRenderer } from '../../helpers/fuel-level-cluster-renderer.helper';
import { FuelLevelMapInfoWindowBuilder } from '../../helpers/fuel-level-map-info-window-builder.helper';
import { FuelLevelMarkerFactory } from '../../helpers/fuel-level-marker-factory.helper';
import { FuelLevel } from '../../models/fuel-level.model';
import { CommonMap } from '../../../_shared';
import { Subscription } from 'rxjs';
import { FuelLevelStateService } from '../../services/fuel-level-state.service';

@Component({
  selector: 'app-fuel-level-map',
  standalone: true,
  imports: [CommonMap],
  templateUrl: './fuel-level-map.component.html',
  styleUrl: './fuel-level-map.component.scss'
})
export class FuelLevelMapComponent implements OnDestroy {
  private readonly transloco = inject(TranslocoService);
  private stateservice: FuelLevelStateService = inject(FuelLevelStateService);
  private router: Router = inject(Router);
  private activatedRoute: ActivatedRoute = inject(ActivatedRoute);

  private subscription!: Subscription;

  public isCollapsed: boolean = false;
  public routeLink: string = '';

  public isLoading: Signal<boolean>;
  public fuelLevels: Signal<FuelLevel[]>;
  public markerFactory = new FuelLevelMarkerFactory();
  public clusterRenderer = new FuelLevelClusterRenderer();
  public mapInfoWindowBuilder = new FuelLevelMapInfoWindowBuilder(key => this.transloco.translate(key));
  public mapCenter: google.maps.LatLngLiteral | null = null;

  ngOnInit(): void {
    this.setRouteLink();
    this.fuelLevels = this.stateservice.fuelLevels;
    this.isLoading = this.stateservice.isLoading;
    if (this.isCollapsed && (this.fuelLevels === null || this.fuelLevels === undefined || this.fuelLevels().length === 0)) {
      this.router.navigate(['/fuel-management/fuel-level']);
    }

    this.subscription = this.stateservice.fuelLevelSelected$.subscribe(() => {

      if (this.fuelLevels().length === 1) {
        const item = this.fuelLevels()[0];
        this.mapCenter = {
          lat: item.latitude,
          lng: item.longitude
        }
      } else {
        this.mapCenter = null;
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  setRouteLink(): void {
    const currentPage = this.activatedRoute.snapshot.routeConfig?.path || '';
    this.isCollapsed = !currentPage.includes('map');
    this.routeLink = this.isCollapsed ? '/fuel-management/fuel-level/fuel-level-map' : '/fuel-management/fuel-level';
  }
}
